(async () => {
    if (!customElements.get("media-slider-swiper")) {
        const {
            default: Swiper,
            Navigation,
            Pagination,
            Autoplay
        } = await import("./swiper.esm-357e3607.async.js");
        const {
            Fancybox
        } = await import("./fancybox.esm-575fa3d8.async.js");
        Swiper.use([Navigation, Pagination, Autoplay]);
        class HeroSwiper extends HTMLElement {
            constructor() {
                super();
                this.swiperElement = this.querySelector("[data-swiper-media-slider]");
                this.swiperOptions = {
                    threshold: 10,
                    observer: true
                };
                if (this && this.dataset && this.dataset.options) {
                    const jsonOptions = JSON.parse(this.dataset.options);
                    if (jsonOptions) {
                        this.swiperOptions = {
                            ...this.swiperOptions,
                            ...jsonOptions
                        }
                    }
                }
                if (Shopify.designMode && this.swiperElement) {
                    const sectionSettings = JSON.parse(this.closest("[data-shopify-editor-section]").dataset.shopifyEditorSection);
                    window.addEventListener("shopify:section:load", (() => {
                        this.swiperElement.update()
                    }));
                    window.addEventListener("shopify:block:select", (event => {
                        if (event.detail.sectionId === sectionSettings.id) {
                            this.handleSectionEvents(event)
                        }
                    }))
                }
                this.init();
                if (this.swiperOptions.fancybox) {
                    this.fancybox()
                }
            }
            init() {
                this.swiperElement = new Swiper(this.swiperElement, this.swiperOptions);
                this.swiperElement.on("slideChange", (function(swiper) {
                    const previousSlide = swiper.slides[swiper.previousIndex];
                    const currentSlide = swiper.slides[swiper.activeIndex];
                    let videoElements;
                    this.breakpoints = breakpoints();
                    if (previousSlide.classList.contains("media-slider__slide--video")) {
                        videoElements = previousSlide.querySelectorAll("[data-video-element]");
                        videoElements.forEach((videoElement => {
                            videoElement.pauseVideo(videoElement.player)
                        }))
                    }
                    if (currentSlide.classList.contains("media-slider__slide--video")) {
                        videoElements = currentSlide.querySelectorAll("[data-video-element]");
                        videoElements.forEach((videoElement => {
                            this.videoOptions = JSON.parse(videoElement.dataset.options);
                            this.breakPointName = this.breakpoints[this.videoOptions.video_breakpoint][0];
                            this.breakPointSize = this.breakpoints[this.videoOptions.video_breakpoint][1];
                            if (this.videoOptions.mp4_desktop && this.videoOptions.mp4_mobile) {
                                if (this.videoOptions.autoplay) {
                                    videoElement.playVideo(videoElement.player)
                                }
                            } else if (this.videoOptions.mp4_desktop && !this.videoOptions.mp4_mobile && window.innerWidth >= this.breakPointSize && videoElement.parentNode.classList.contains(`visibility-${this.breakPointName}--visible`)) {
                                if (this.videoOptions.autoplay) {
                                    videoElement.playVideo(videoElement.player)
                                }
                            } else if (!this.videoOptions.mp4_desktop && this.videoOptions.mp4_mobile && window.innerWidth < this.breakPointSize && videoElement.parentNode.classList.contains(`visibility-${this.breakPointName}--hidden`)) {
                                if (this.videoOptions.autoplay) {
                                    videoElement.playVideo(videoElement.player)
                                }
                            }
                        }))
                    }
                }))
            }
            fancybox() {
                if (typeof Swiper == "undefined") {
                    return false
                }
                Fancybox.bind("[data-fancybox]", {
                    animated: false,
                    showClass: false
                })
            }
            handleSectionEvents(event) {
                this.swiperElement.slideTo(parseInt(event.target.dataset.swiperSlideIndex) + 1)
            }
        }
        window.HeroSwiper = HeroSwiper;
        customElements.define("media-slider-swiper", HeroSwiper)
    }
})();
//# sourceMappingURL=media-slider.js.map